module.exports = require("core-js/library/fn/json/stringify");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/json/stringify.js
// module id = 81
// module chunks = 0 2 4